import { ValidationItemModel } from './ValidationItemModel';

export class DataResponseModel {
    isSuccess: boolean;
    affectedRecords: number;
    endUserMessage: string;
    validationErrors: [ValidationItemModel];
    timeGenerated: Date;
}
